module.exports = __webpack_public_path__ + "static/media/user.46921460.jpg";